<template>
  <div class="upload-file-modal">
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible">
      <el-upload
          drag
          ref="upload"
          action=""
          :limit="1"
          :on-exceed="onExceed"
          :auto-upload="false"
          :file-list="fileList"
          :show-file-list="true"
          :on-remove="handleRemove"
          :on-change="upload">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          <ul>
            <li v-if="tip">{{tip}}</li>
            <li v-for="item in validatesDesc" v-if="validateFile">
              {{item}}
            </li>
          </ul>
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clear" v-if="showClearBtn" type="danger" size="small">清 除</el-button>
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button @click="submit" type="primary" size="small" :disabled="onUploading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import objectToFormData from 'object-to-formdata'

export default {
  name: 'SjUploadModal',
  props: {
    title: {
      type: String,
      default: '上传',
    },
    tip: {
      type: String,
      default: '',
    },
    fileExtension: {
      type: String,
      default: '',
    },
    fileMaxSize: {
      type: Number,
      default: 0,
    },
    fileMinSize: {
      type: Number,
      default: 0,
    },
    validateFile: {
      type: Boolean,
      default: false,
    },
    request: {
      type: String,
      required: true,
      default: '',
    },
    requestData: Object,
    showClearBtn: {
      type: Boolean,
      default: true,
    },
    files: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    validatesDesc () {
      let items = []
      if (this.validateFile) {
        if (this.fileExtension) {
          items.push(this.validationStrings.extension = `必须为${this.fileExtension}文件`)
        }
        if (this.fileMaxSize) {
          let humanSize = Math.round(this.fileMaxSize / 1024 / 1024) + 'Mb'
          items.push(this.validationStrings.maxSize = `文件不能大于${humanSize}`)
        }
        if (this.fileMinSize) {
          let humanSize = Math.round(this.fileMinSize / 1024 / 1024) + 'Mb'
          items.push(this.validationStrings.minSize = `文件不能小于${humanSize}`)
        }
      }
      return items
    },
  },
  watch: {
    dialogVisible: function (val) {
      if (val === false) {
        this.result = null
        this.uploaded = null
        this.onUploading = false
        this.$refs.upload.clearFiles()
      }
    },
    files: function (val) {
      this.fileList = val
    }
  },
  data () {
    return {
      dialogVisible: false,
      onUploading: false,
      params: null,
      result: null,
      validationStrings: {
        extension: '',
        maxSize: '',
        minSize: '',
      },
      uploaded: false,
      fileList: [],
    }
  },
  methods: {
    open (params) {
      this.params = params
      this.dialogVisible = true
    },
    upload (file) {
      const formFile = file.raw
      if (this.validateFile) {
        if (this.fileExtension.length > 0 && _.endsWith(formFile.name, '.' + this.fileExtension) === false) {
          return this.validateFailed(this.validationStrings.extension)
        }
        if (this.fileMaxSize > 0 && formFile.size > this.fileMaxSize) {
          return this.validateFailed(this.validationStrings.maxSize)
        }
        if (this.fileMinSize > 0 && formFile.size < this.fileMinSize) {
          return this.validateFailed(this.validationStrings.minSize)
        }
      }

      let formData = objectToFormData(this.requestData)
      formData.append('file', formFile)
      this.onUploading = true

      return request.common(this.request, formData).then(({data}) => {
        if (typeof data === 'string') {
          this.result = {
            url: data,
            name: formFile.name
          }
        } else {
          this.result = data
        }
        this.uploaded = true
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      }).catch(() => {
        this.$refs.upload.clearFiles()
      }).finally(() => {
        this.onUploading = false
      })
    },
    handleRemove (file, fileList) {
      this.result = null
      this.fileList = fileList
    },
    submit () {
      this.dialogVisible = false
      if (this.uploaded) {
        this.$emit('uploaded', this.result, this.params)
      } else if (!this.fileList.length) {
        this.$emit('uploaded', null, this.params)
      }
    },
    clear () {
      this.$confirm('你确定需要清除已上传的文件吗？', '提示', {type: 'warning'}).then(() => {
        this.dialogVisible = false
        this.$emit('uploaded', null, this.params)
      })
    },
    validateFailed (why) {
      this.$message.error(why)
      this.$refs.upload.clearFiles()
    },
    onExceed () {
      this.$message.error('文件数量超出限制')
    }
  }
}
</script>

<style lang="scss"
       scoped>
.upload-file-modal /deep/ .el-dialog {
  width: 30%;
  min-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/sj-upload-modal/SjUploadModal.vue